import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer>
      <div className="container">
        <p>&copy; 2026 SLOOMWEEP</p>
      </div>
    </footer>
  );
}

export default Footer;

